module.exports = __webpack_public_path__ + "img/Group 1004three-1.8e1692aa.png";